import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Infographics </h1>


    
    <div className="imgs max500">
        <div>
            <img src={require('../assets/graphicDesign/infographics/grid1-01_pixellated.jpg')} data-skip-gallery/>
        </div>
    </div>

    <p>I designed the displayed infographics to help explain and visualize the complexities of a rare disease 
    called MPS I. Included in the topics covered are cellular, symptoms, and severity explanations. I initially designed a wide range of different looks and styles, and then honed in on 
    a certain branding style that the client enjoyed from the initial designs.</p>

    <div className="imgs max500">
        <div>
            <img src={require('../assets/graphicDesign/infographics/grid2.jpg')} data-skip-gallery/>
        </div>
    </div>

    

    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.